import { Environment } from "./types";

export const API_ROOT = "https://nwood6azg6.execute-api.us-east-1.amazonaws.com/Prod/api";

export const ENVIRONMENT: Environment = process.env.ENVIRONMENT as Environment;
